import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import { FlightsService } from 'app/features/flights/services/flight.service';
import { FlightsLegendHelpComponent } from 'app/features/flights/flights-legend-help/flights-legend-help.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SkeletonModule } from 'primeng/skeleton';
import { FilterFlightsComponent } from 'app/features/flights/flight-list/flight-filter/filter-flights.component';

@Component({
    selector: 'app-flights-toolbar',
    imports: [
        CommonModule,
        SkeletonModule,
    ],
    templateUrl: './flights-toolbar.component.html',
    styleUrl: './flights-toolbar.component.scss',
    providers: [DialogService]
})
export class FlightsToolbarComponent implements OnDestroy {


  constructor(
    private flightService: FlightsService,
    private dialogService: DialogService,
  ) {}

  @Input() lastUpdatedTb?: string;
  ref: DynamicDialogRef | undefined;
  footer?: string;
  //destroy$ = new Subject<void>();
  appSettings$ = this.flightService.settingsChangedAction$

  onRefreshClicked(): void {
    this.flightService.forceRefresh();
  }


  onOpenDialog(dialogType: string): void {
    let component: any;
    let title: string = '';
    if (dialogType === 'filter') {
      component = FilterFlightsComponent;
      title = 'Sort/Filter Flights';
    } else if (dialogType === 'legend') {
      component = FlightsLegendHelpComponent;
      title = 'Flights Legend';
    }
  
    this.ref = this.dialogService.open(component, {
      header: `${title}`,
      width: '50vw',
      modal: true,
      dismissableMask: true,
      closable: true,
      breakpoints: {
        '4000px': '30vw',
        '1180px': '40vw',
        '900px': '50vw',
        '700px': '60vw',
        '600px': '70vw',
        '500px': '98vw'
      },
      contentStyle: {
        'background-color': 'var(--surface-0)',
        'padding-top': '10px'
      },
      footer: this.footer,
    });
  }

  ngOnDestroy(): void {
    if (this.ref) {
      this.ref.close();
    }
  }
}
